import { all } from 'redux-saga/effects';
import authSagas from './Auth';
import userSagas from './User';
import orgSagas from './Org';
import propertiesSaga from './Properties';
import panelSagas from './Panels';
import intercomSagas from './Intercom';
import callsSagas from './Calls';
import virtualGuardSagas from './VirtualGuard';
import membersSagas from './Members';
import otcSagas from './Otc';
import liveKitSagas from './LiveKit';
import reservationsSaga from './Reservations';
import deviceOperationsSagas from './DeviceOperations';
import managersSaga from './Managers';
import reportsSagas from './Reports';
import accessLogSaga from './AccessLogs';
import rentalsSaga from './Rentals';
import incidentReportsSaga from './IncidentReports';

export default function* rootSaga() {
    yield all([
        authSagas(),
        userSagas(),
        orgSagas(),
        propertiesSaga(),
        panelSagas(),
        intercomSagas(),
        callsSagas(),
        virtualGuardSagas(),
        membersSagas(),
        otcSagas(),
        reservationsSaga(),
        liveKitSagas(),
        deviceOperationsSagas(),
        managersSaga(),
        reportsSagas(),
        accessLogSaga(),
        rentalsSaga(),
        incidentReportsSaga()
    ]);
}
